const OSS = require('ali-oss')
import { getOssSts } from '@/api/data'

// 获取STS客户端（用于temp-aidoohiky bucket）
export async function getOssClient() {
  try {
    const res = await getOssSts()
    if (res.data.code === 200) {
      const stsData = res.data.data
      return new OSS({
        region: 'oss-cn-shenzhen',
        accessKeyId: stsData.accessKey,
        accessKeySecret: stsData.accessKeySecret,
        stsToken: stsData.token,
        bucket: 'temp-aidoohiky',
        secure: true,
        timeout: 6000000
      })
    }
    throw new Error('获取STS token失败')
  } catch (error) {
    console.error('获取STS token失败:', error)
    throw error
  }
}

// 获取STS客户端（用于temp-aidoohiky bucket - 备用）
export async function getOssClientId() {
  try {
    const res = await getOssSts()
    if (res.data.code === 200) {
      const stsData = res.data.data
      return new OSS({
        region: 'oss-cn-shenzhen',
        accessKeyId: stsData.accessKey,
        accessKeySecret: stsData.accessKeySecret,
        stsToken: stsData.token,
        bucket: 'temp-aidoohiky',
        secure: true,
        timeout: 6000000
      })
    }
    throw new Error('获取STS token失败')
  } catch (error) {
    console.error('获取STS token失败:', error)
    throw error
  }
}

